import { isArray } from 'lodash';

export const filterByKeyAndValue = (key, value, list) => {
  let arr = [];
  if (!isArray(list)) arr = [list];
  else arr = list;
  return arr.filter(item => item[key] === value);
};

export const listByKeyInObject = (key, list) => {
  let arr = [];
  if (!isArray(list)) arr = [list];
  else arr = list;
  return arr
    .map(item => {
      return item[key] ?? [];
    })
    .flat();
};

export const isEmpty = a =>
  Array.isArray(a) ? a.length === 0 : Object.keys(a).length === 0;
